import { faker } from '@faker-js/faker';
import { Stack } from '@mui/material';
import _ from 'lodash';
import { DateTime } from 'luxon';
import {
  LogEvent,
  MilestoneDetailCardLayout
} from 'modules/components/layer05';
import React from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';


export type MilestoneHistoryCardProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: MilestoneHistoryCardProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.milestoneId ?? '');

  return (
    <MilestoneDetailCardLayout.FC
      title='History'
      subTitle='Milestone Changes'
      actionButton={null}
    >
      <Stack
        rowGap='1rem'
      >
        {data.events.map((node) => (
          <LogEvent.FC
            createdAt={node.createdTimestamp.toFormat('yyyy-LL-dd')}
            description={node.description}
            id={node.title}
            personName={node.createdBy?.fullName ?? 'Person Not Found'}
            key={node.id}
          />
        ))}
      </Stack>

    </MilestoneDetailCardLayout.FC>
  );
};
